module.exports = __webpack_public_path__ + "static/scale-model-of-the-rose-garden-at-mcc-in-tempe-arizona-19bc080bc4710469ff0fa6c225fb6ae9.png";